module.exports = __webpack_public_path__ + "static/media/Virmon-Tumulak-1.ebc87b30.pdf";